export const navLinks = [
  {
    name: 'Home',
    nameAr: 'الرئيسية',
    path: '/',
  },
  {
    name: 'Services',
    nameAr: 'خدماتنا',
    path: '/services',
  },
  {
    name: 'Packages',
    nameAr: 'الباقات',
    path: '/packages',
  },
  {
    name: 'Gallery',
    nameAr: 'المعرض',
    path: '/gallery',
  },
  {
    name: 'Reviews',
    nameAr: 'التقييمات',
    path: '/reviews',
  },
  {
    name: 'About Us',
    nameAr: 'من نحن',
    path: '/about',
  },
  {
    name: 'Contact',
    nameAr: 'اتصل بنا',
    path: '/contact',
  },
];
